<template>
  <div class="t-vote">
    <span class="t-vote__label" v-if="count !== undefined">{{ count }}</span>

    <img
      class="t-vote__image"
      :class="{
        't-vote__image--approve': this.type,
        't-vote__image--reject': !this.type,
      }"
      :src="imageSrc"
      :alt="imageAlt"
    />
  </div>
</template>

<script>
  export default {
    props: {
      type: { type: Boolean, required: true },
      count: { type: Number },
    },
    computed: {
      imageSrc() {
        const imageName = this.type ? 'approve' : 'reject';

        return require(`../assets/img/game/${imageName}.png`);
      },
      imageAlt() {
        return this.type ? 'Approved' : 'Rejected';
      },
    },
  };
</script>

<style lang="scss">
  .t-vote {
    display: flex;
    align-items: center;

    &__label {
      color: white;
      font-size: 28px;
      margin-right: 8px;
    }

    &__image {
      width: 100%;
      border-radius: 50%;
      border: 1px solid;

      &--approve {
        border-color: #66c339;
      }

      &--reject {
        border-color: #c33937;
      }
    }
  }
</style>
